/**
 * Shared utilities for signature status components
 */

/**
 * Formats a signature date with timezone information
 * @param signedAt - ISO date string or null/undefined
 * @returns Formatted date string with timezone, or empty string if no date
 */
export const formatSignatureDate = (
  signedAt: string | null | undefined,
): string => {
  if (!signedAt) return '';

  try {
    const date = new Date(signedAt);

    // Validate the date
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }

    // Format the date
    const dateStr = date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    // Extract timezone abbreviation
    const timeZone = date
      .toLocaleTimeString('en-US', {
        timeZoneName: 'short',
      })
      .split(' ')
      .pop();

    return `${dateStr} ${timeZone}`;
  } catch {
    return 'Unknown date';
  }
};
